import * as types from '../NGUD/types';

const state = {
  loopIndicators: []
};

const getters = {
  [types.LOOP_INDICATORS]: state => {
    return state.loopIndicators;
  }
};

const mutations = {
  [types.MUTATE_SET_LOOP_INDICATORS]: (state, payload) => {
    state.loopIndicators = payload;
  }
};

const actions = {};

export default {
  actions,
  state,
  getters,
  mutations
};
